export default "__VITE_ASSET__d94d9645__"